import React from 'react';
import { useTranslation } from 'react-i18next';
import { Modal, Loader } from 'react-inv-forms';

import fingerPrintIcon from '../../../images/fingerPrintIcon.svg';
import { SigninMarksLoaderContainer } from './SigninMarksLoaderModal.style';
interface Props {
  /** stan otwarcia modala */
  opened: boolean;
}

/**
 * Komponent modala podpisu ocen z loaderem
 *
 */
const SigninMarksLoaderModal: React.FunctionComponent<Props> = (props: Props) => {
  const { t } = useTranslation();
  const { opened } = props;
  return (
    <Modal
      visible={opened}
      title={
        <span>
          <img alt='finger print icon' src={fingerPrintIcon} />
          {t('MARKS_SIGNING_IN_PROGRESS')}
        </span>
      }
      maskClosable={false}
      closable={false}
      footer={null}
    >
      <SigninMarksLoaderContainer>
        <Loader />
      </SigninMarksLoaderContainer>
    </Modal>
  );
};

export default SigninMarksLoaderModal;
